import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { BaseService } from '../../shared/services/base.service';
import { DialogConfig } from '../dialog/dialog-config';
import { DialogRef } from '../dialog/dialog-ref';

@Component({
    selector: 'app-aunthication-flag',
    templateUrl: './aunthication-flag.component.html',
    styleUrls: ['./aunthication-flag.component.scss'],
    standalone: false
})
export class AunthicationFlagComponent implements OnInit {
  @Input() data: any;
  _currentData: any = {};
  _currentAction = 'ADD';
  customButton: any = {};
  application: any;
  id: any = [];
  actionType: any;
  config: any;
  showForm:boolean=false;
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent: ViewContainerRef;
  btn: any;
  constructor(
    private dialogRef: DialogRef,
    private baseService:BaseService, private alerts:AlertsService,private loader:LoaderService
  ) { }

  ngOnInit(): void {
    console.log("data",this.data);
    this.btn = this.data['action'] != undefined && this.data['action'].form != undefined && this.data['action'].form.buttons ? this.data['action'].form.buttons : {
      "Add": [
        {
          "label": "Submit",
          "icon": "fa fa-check"
        }
      ],
      "Modify": [
        {
          "label": "Submit",
          "icon": "fa fa-check"
        }
      ]
    };
    this.config = {
      "submitButton": true,
      "filterForm": false,
      "clearOnSave": true,
      "delegateSave": true,
      "cancelRoute": '',
      "compositearray_action": 'ADD'
    }
    let form =  {
      "blocks": [
          {
              "name": "basic_information",
              "class_name": "null",
              "order": 1,
              "fields": [
                  {
                      "label": "field.label.hims_auth",
                      "class_name": "kx-control col-lg-4 col-md-4 col-sm-4 col-xl-4 mb-4 fix",
                      "order": 1,
                      "type": "String",
                      "required": true,
                      "getterKey": "code",
                      "getterValue": "display",
                      "minlength": 2,
                      "component": "dropdown",
                      "req_keys": [
                        "code",
                        "display"
                    ],
                      "datasource": {
                        "application": "system-management",
                        "resource": "valueset",
                        "query_id": "get_valueset_by_id_flat",
                        "args": "resourceId:hims_auth,system:karexpert",
                        "key": "id"
                    },
                      "name": "hims_auth"
                  },
                  {
                    "type": "String",
                    "component": "hidden",
                    "name": "id"
                }
              ],
              "title": ""
          }
      ]
  }
    this._currentData={
      _currentFormFields:form,
      _currentData:this.data
    }
    this.getAuthenticationData();
  }
  closePopUp(){
    this.dialogRef.close();
  }
  onSaveFinished(event){
    if(event && event.result){
      this.loader.showSpinner();
      this.baseService
      .action(event.result, "set_hims_auth", "account-management", "manage_users", false)
      .subscribe(
        (res) => {
          if (res.errCode == 0) {
            this.alerts.success("Success");
            this.loader.hideSpinner();
            this.closePopUp();
          } else if (res.errCode == -1) { 
            this.alerts.error(res.message);
            this.loader.hideSpinner();
          }
        },
        (err) => {
          this.loader.hideSpinner();
        }
      );
    }
  }
  getAuthenticationData(){
    let data = {id:this.data.id}
    if(data && data.id){
      this.loader.showSpinner();
      this.baseService.action(data,"get_auth_flag","account-management","manage_users","").subscribe((res)=>{
        if(res && res.resource && res.resource.length>0){
          let auth = res.resource[0];
          this._currentData._currentData = auth;
          this.showForm =true;
          console.log("response to fill auth form",res);
          this.loader.hideSpinner();
        }
      },(err)=>{
        this.showForm =false;
        this.loader.hideSpinner();
      })
    }
  } 
}
